export default {
  methods: {
    turnToPage(route) {
      if (typeof route === 'string') {
        this.$router.push({ name: route })
      } else {
        const { name, subPath, fullPath, params, query } = route
        const r = { params, query }
        if (fullPath || subPath) {
          r.path = fullPath || subPath
        } else {
          r.name = name
        }
        this.$router.push(r)
      }
    }
  }
}
